import { render, staticRenderFns } from "./ButtonCard.vue?vue&type=template&id=449ab4de&scoped=true"
import script from "./ButtonCard.vue?vue&type=script&lang=js"
export * from "./ButtonCard.vue?vue&type=script&lang=js"
import style0 from "./ButtonCard.vue?vue&type=style&index=0&id=449ab4de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449ab4de",
  null
  
)

export default component.exports